<template>
  <section>
    <h3 class="primary--text">
      <v-icon color="primary">business</v-icon>Registro de Orientaciones
    </h3>
    <div>
      <v-toolbar flat color="white">
        <v-toolbar-title>Orientaciones</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-dialog v-model="dialog2" max-width="900px" persistent>
          <v-card class="elevation-2">
            <v-timeline align-top>
              <v-timeline-item
                v-for="(item, i) in tramites"
                :color="item.color"
                :icon="item.icon"
                :key="i"
                fill-dot
              >
                <v-card :color="item.color" dark>
                  <v-card-title class="title">{{item.etapa}}</v-card-title>
                  <v-card-text class="white text--primary">
                    <p>{{item.proveido}}</p>
                    <p>{{item.fecha | formatDate}}</p>
                    <p>{{item['res_tramite.persona.nombre_completo']}}</p>
                    <v-btn :color="item.color" class="mx-0" outline>Button</v-btn>
                  </v-card-text>
                </v-card>
              </v-timeline-item>
            </v-timeline>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click.native="close2">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogVisor" max-width="700px" persistent>
          <!-- <v-btn slot="activator" color="primary" dark class="mb-2">Nuevo Solicitante</v-btn> -->
          <v-card>
            <v-card-title class="headline grey lighten-3" primary-title>Datos de la orientación</v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs4>
                    <v-subheader>CI Solicitante:</v-subheader>
                  </v-flex>
                  <v-flex xs6>
                    <v-card-text>
                      <p class="text-sm-left">{{filaActual.ci}}</p>
                    </v-card-text>
                  </v-flex>
                  <v-flex xs4>
                    <v-subheader>Nombre Solicitante:</v-subheader>
                  </v-flex>
                  <v-flex xs6>
                    <v-card-text>
                      <p class="text-sm-left">{{filaActual.solicitante}}</p>
                    </v-card-text>
                  </v-flex>
                  <v-flex xs4>
                    <v-subheader>Motivo Orientación:</v-subheader>
                  </v-flex>
                  <v-flex xs6>
                    <v-card-text>
                      <p class="text-sm-left">{{filaActual.motivo}}</p>
                    </v-card-text>
                  </v-flex>
                  <v-flex xs4>
                    <v-subheader>Conclusión / Recomendación:</v-subheader>
                  </v-flex>
                  <v-flex xs6>
                    <v-card-text>
                      <p class="text-sm-left">{{filaActual.conclusion}}</p>
                    </v-card-text>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click.native="closeVisor">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogEnviar" max-width="700px" persistent>
          <v-card>
            <v-form ref="formEnviar" v-model="valid" lazy-validation>
              <v-card-title class="headline grey lighten-3" primary-title>Envío de la orientación</v-card-title>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6>
                    <v-subheader>CI Solicitante:</v-subheader>
                    <v-card-text>
                      <p class="text-sm-left">{{filaActual.ci}}</p>
                    </v-card-text>
                  </v-flex>

                  <v-flex xs12 sm6>
                    <v-subheader>Nombre Solicitante:</v-subheader>
                    <v-card-text>
                      <p class="text-sm-left">{{filaActual.solicitante}}</p>
                    </v-card-text>
                  </v-flex>

                  <v-flex xs12 sm6>
                    <v-select
                      v-model="select_etapa"
                      :items="flujoDestino"
                      item-text="flujo_destino"
                      item-value="flujoDestino"
                      label="Enviar a"
                      persistent-hint
                      return-object
                      :rules="[v => !!v || 'Etapa destino es requerido']"
                      required
                      class="required"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-select
                      v-model="select_abogado"
                      :items="abogado"
                      item-text="nombre"
                      item-value="id"
                      label="Abogado / Psicólogo "
                      persistent-hint
                      return-object
                      :rules="[v => !!v || 'Abogado destino es requerido']"
                      required
                      class="required"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      v-model="proveido"
                      auto-grow
                      box
                      color="blue"
                      label="Proveído"
                      rows="3"
                      counter="300"
                      :rules="[v => !!v || 'El proveído es requerido']"
                      required
                      class="required"
                    ></v-textarea>
                  </v-flex>
                </v-layout>
              </v-container>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" flat @click.native="closeEnviar">Cancelar</v-btn>
                <v-btn color="blue darken-1" flat @click.native="validate">Guardar</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="700px" persistent>
          <!-- <v-btn slot="activator" color="primary" dark class="mb-2">Nuevo Solicitante</v-btn> -->
          <v-card>
            <v-form ref="form" v-model="validCompletar" lazy-validation>
              <v-card-title class="headline grey lighten-3" primary-title>{{ formTitle }}</v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md3>
                      <v-text-field v-model="editedItem.ci" label="CI Solicitante" readonly></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md7>
                      <v-text-field
                        v-model="editedItem.solicitante"
                        label="Nombre Solicitante"
                        readonly
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md2 v-if="!victimaBan">
                      <v-checkbox v-model="swv" label="Es afectado (a) directo?" color="orange" hide-details></v-checkbox>
                    </v-flex>

                    <!-- Datos de la victima -->
                    <v-card v-if="!swv" color="indigo lighten-4 ma-0">
                      <!-- <v-card-title class="headlineindigo lighten-4" primary-title>Datos de la víctima</v-card-title> -->
                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>
                            <v-flex xs12 sm6 md4>
                              <v-text-field
                                v-model="victima.ci"
                                label="CI víctima"
                                class="required"
                                required
                                maxlength="20"
                                @keydown.native="$filter.numeric($event)"
                                :rules="ciRules"
                                :counter="12"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                              <v-text-field
                                v-model="victima.nombres"
                                label="Nombres víctima"
                                required
                                maxlength="30"
                                class="required"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                              <v-text-field
                                v-model="victima.primer_apellido"
                                label="Primer apellido víctima"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                              <v-text-field
                                v-model="victima.segundo_apellido"
                                label="Segundo apellido víctima"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                              <v-select
                                v-model="select_nacionalidad"
                                :items="nacionalidad"
                                item-text="valor"
                                item-value="clave"
                                label="Nacionaldad"
                                persistent-hint
                                return-object
                                required
                                class="required"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                              <v-menu
                                ref="menu"
                                :close-on-content-click="false"
                                v-model="menu"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                              >
                                <v-text-field
                                  slot="activator"
                                  v-model="date"
                                  label="Fecha de Nacimiento"
                                  prepend-icon="event"
                                  readonly
                                ></v-text-field>
                                <v-date-picker
                                  ref="picker"
                                  v-model="date"
                                  :max="new Date().toISOString().substr(0, 10)"
                                  min="1900-01-01"
                                  @change="dateClose"
                                  required
                                  class="required"
                                ></v-date-picker>
                              </v-menu>
                            </v-flex>

                            <v-flex xs12 sm6 md4>
                              <v-checkbox
                                v-model="victima.discapacidad"
                                label="Discapacidad"
                                color="orange"
                                value="1"
                                hide-details
                              ></v-checkbox>
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                              <v-select
                                v-model="select_genero"
                                :items="genero"
                                item-text="valor"
                                item-value="clave"
                                label="Género"
                                persistent-hint
                                return-object
                                required
                                class="required"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                              <v-select
                                v-model="select_departamento"
                                :items="departamento"
                                item-text="nombre"
                                item-value="codigo"
                                label="Departamento"
                                persistent-hint
                                return-object
                              ></v-select>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                    <!-- FIN Datos de la victima -->
                    <v-container fill-height fluid pa-2>
                      <v-flex xs6>
                        <v-textarea
                          v-model="editedItem.motivo"
                          auto-grow
                          box
                          color="blue"
                          label="Motivo de la consulta"
                          rows="5"
                          counter="1000"
                          :rules="[v => !!v || 'El motivo es requerido']"
                          required
                          class="required"
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs6>
                        <v-textarea
                          v-model="editedItem.conclusion"
                          auto-grow
                          box
                          color="blue"
                          label="Conclusión y Recomendación"
                          rows="5"
                          counter="1000"
                          :rules="[v => !!v || 'Laconclusión es requerida']"
                          required
                          class="required"
                        ></v-textarea>
                      </v-flex>
                    </v-container>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" flat @click.native="close">Cancelar</v-btn>
                <v-btn color="blue darken-1" flat @click.native="validateCompletar">Guardar</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </v-toolbar>

      <!-- Listado -->
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="desserts"
        class="elevation-1"
        :pagination.sync="pagination"
        :total-items="pagination.totalItems"
        rowsPerPageText="Filas por página"
        noResultsText="No se encontraron registros que coincidan"
        noDataText="No hay resultados"
        :rowsPerPageItems="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td class="justify-left layout px-0">
            <v-tooltip bottom>
              <v-icon
                slot="activator"
                v-if="props.item.estado === 'ENVIADO'|| props.item.estado === 'FINALIZADO'"
                color="light-green lighten-1"
                @click="visorItem(props.item)"
              >visibility</v-icon>
              <span>Ver Caso</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-icon
                slot="activator"
                v-if="props.item.estado === 'ACTIVO'"
                color="light-green darken-2"
                @click="editItem(props.item)"
              >assignment</v-icon>
              <span>Completar Orientación</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-icon
                slot="activator"
                color="light-green darken-4"
                class="mr-2"
                @click="flowItem(props.item)"
              >call_split</v-icon>
              <span>Ver historial</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-icon
                slot="activator"
                v-if="props.item.motivo && props.item.conclusion && props.item.estado === 'ACTIVO'"
                class="mr-2"
                @click="enviarItem(props.item)"
                flat
                color="cyan lighten-2"
              >send</v-icon>
              <span>Enviar Caso</span>
            </v-tooltip>
          </td>
          <td>{{ props.item.codigo }}</td>
          <td class="text-xs-right">{{ props.item.ci }}</td>
          <td class="text-xs-right">{{ props.item.solicitante }}</td>
          <td class="text-xs-right">{{ props.item.enviado_por }}</td>
          <td class="text-xs-right">{{ props.item.fecha | formatDate }}</td>
          <td class="text-xs-right">{{ props.item.estado }}</td>
          <td class="text-xs-right" v-if="$util.isRol('DIRECTOR')">{{ props.item.centro }}</td>
          <td class="text-xs-right" v-if="$util.isRol('DIRECTOR')">{{ props.item.abogado }}</td>
        </template>
        <template
              slot="pageText"
              slot-scope="{ pageStart, pageStop }"
            >{{ pageStart }}-{{ pageStop }} de {{ pagination.totalItems }}</template>
            
        <!-- <v-alert
          slot="no-results"
          :value="true"
          color="info"
          icon="warning"
        >Tu búsqueda para "{{ search }}" no obtuvo resultados</v-alert> -->
      </v-data-table>
    </div>
  </section>
</template>

<script>
import moment from 'moment';

export default {
  data: () => ({
    rowsPerPageItems: [5, 10, 20],
    pagination: {
      rowsPerPage: 5,
      page: 1
    },
    valid: true,
    validCompletar: true,
    dialog: false,
    dialog2: false,
    dialogVisor: false,
    dialogEnviar: false,
    filaActual: {},
    flujoDestino: [],
    select_idioma: { valor: 'Castellano', clave: 'CASTELLANO' },
    select_estado_civil: { valor: 'Soltero (a)', clave: 'SOLTERO' },
    select_genero: { valor: 'Femenino', clave: 'FEMENINO' },
    select_departamento: { nombre: 'La Paz', codigo: '02' },
    // select_abogado: { nombre: 'Abogado', id: 0 },
    select_abogado: null,
    // select_etapa: { valor: 'Conciliación', clave: 'CONCILIACION' },
    select_etapa: null,
    select_nacionalidad: { valor: 'BOLIVIANA', clave: 'BOLIVIANA' },
    tramites: [],
    nacionalidad: [],
    idioma: [],
    estado_civil: [],
    genero: [],
    departamento: [],
    abogado: [],
    proveido: '',
    enviar: false,
    search: '',
    headers: [],
    desserts: [],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
    date: null,
    menu: false,
    swv: true,
    victima: {},
    victimaBan: null
  }),
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) {
        return 1;
      }
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    formTitle () {
      return this.editedIndex === -1 ? 'Datos del Solicitante' : 'Orientación ';
    }
  },

  filters: {
    formatDate: function (value) {
      return moment(String(value)).format('DD/MM/YYYY HH:mm');
    }
  },

  watch: {
    dialog (val) {
      val || this.close();
    },
    select_etapa (val) {
      let prof = 'ABOGADO PSICOLOGO';
      if (val.flujo_destino === 'PSICOLOGIA') {
        prof = 'PSICOLOGO';
      }
      if (val.flujo_destino === 'TRABAJO_SOCIAL') {
        prof = 'TRABAJADOR_SOCIAL';
      }
      this.$service['get'](`v1/centros/usuarios?tipo=${prof}`).then(
        response => {
          if (response) {
            this.abogado = response;
          }
        }
      );
    },
    menu (val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'));
    },
    pagination: function () {
      this.listarCasos();
    },
    search: function (filter) {
      this.listarCasos(filter);
    }
  },

  created () {
    if (this.$util.isRol('DIRECTOR')) {
      this.headers = [
        { text: 'Opciones', value: 'name', sortable: false },

        {
          text: 'Código',
          align: 'left',
          sortable: false,
          value: 'codigo'
        },
        { text: 'C. I.', value: 'nro_documento' },
        { text: 'Solicitante', value: 'nombres' },
        { text: 'Enviado por', value: 'apellidos' },
        { text: 'Fecha de asignación', value: 'apellidos' },
        { text: 'Estado', value: 'estado' },
        { text: 'Centro', value: 'centro' },
        { text: 'Abogado', value: 'abogado' }
      ];
    } else {
      this.headers = [
        { text: 'Opciones', value: 'name', sortable: false },

        {
          text: 'Código',
          align: 'left',
          sortable: false,
          value: 'codigo'
        },
        { text: 'C. I.', value: 'nro_documento' },
        { text: 'Solicitante', value: 'nombres' },
        { text: 'Enviado por', value: 'apellidos' },
        { text: 'Fecha de asignación', value: 'apellidos' },
        { text: 'Estado', value: 'estado' }
      ];
    }
    this.initialize();
  },

  methods: {
    initialize () {
      this.listarCasos();
      this.$service['get']('v1/parametricas?grupo=IDIOMA').then(response => {
        if (response) {
          this.idioma = response;
        }
      });
      this.$service['get']('v1/parametricas?grupo=ESTADO_CIVIL').then(
        response => {
          if (response) {
            this.estado_civil = response;
          }
        }
      );
      this.$service['get']('v1/parametricas?grupo=GENERO').then(response => {
        if (response) {
          this.genero = response;
        }
      });
      this.$service['get']('v1/dpas/departamentos').then(response => {
        if (response) {
          this.departamento = response;
        }
      });
      this.$service['get']('v1/parametricas?grupo=TRAMITE_ETAPA').then(
        response => {
          if (response) {
            this.tramite = response;
          }
        }
      );
      this.$service['get']('v1/parametricas?grupo=NACIONALIDAD').then(
        response => {
          if (response) {
            this.nacionalidad = response;
          }
        }
      );
    },
    dateClose (date) {
      this.$refs.menu.save(date);
      this.menu = false;
    },
    flowItem (item) {
      this.$service['get'](`v1/solicitudes/${item.solicitud_id}/tramites`).then(
        response => {
          this.tramites = response;
          this.dialog2 = true;
        }
      );
    },
    visorItem (item) {
      this.filaActual = item;
      this.dialogVisor = true;
    },
    enviarItem (item) {
      this.filaActual = item;
      this.flujoDestino = item.flujo;
      this.dialogEnviar = true;
    },

    editItem (item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.victimaBan = item.victimaBan;
      this.dialog = true;
    },

    deleteItem (item) {
      const index = this.desserts.indexOf(item);
      confirm('Are you sure you want to delete this item?') &&
        this.desserts.splice(index, 1);
    },
    close () {
      this.limpiarFormulario();
      this.victima = {};
      this.swv = true;
      this.dialog = false;
    },
    close2 () {
      this.dialog2 = false;
    },
    closeVisor () {
      this.dialogVisor = false;
    },
    closeEnviar () {
      this.dialogEnviar = false;
    },
    limpiarFormulario () {
      this.select_idioma = { valor: 'Castellano', clave: 'CASTELLANO' };
      this.select_estado_civil = { valor: 'Soltero (a)', clave: 'SOLTERO' };
      this.select_genero = { valor: 'Femenino', clave: 'FEMENINO' };
      this.select_departamento = { nombre: 'La Paz', clave: '02' };
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      this.select_abogado = { nombre: 'Abogado', id: 0 };
    },
    saveOrientacion () {
      let sw = null;
      if (this.swv) sw = 'SI';
      else sw = 'NO';

      let dataVictima = {
        ci: this.victima.ci,
        nombres: this.victima.nombres,
        primer_apellido: this.victima.primer_apellido,
        segundo_apellido: this.victima.segundo_apellido,
        nacionalidad: this.victima.select_nacionalidad,
        fecha_nacimiento: this.date,
        discapacidad: this.editedItem.discapacidad ? 'SI' : 'NO',
        genero: this.select_genero.clave,
        dpa: this.select_departamento.codigo
      };
      let data = {
        motivo: this.editedItem.motivo,
        conclusion: this.editedItem.conclusion,
        victima: dataVictima,
        esVictima: sw
      };
      this.$service['patch'](
        `v1/orientaciones/${this.editedItem.id}`,
        data
      ).then(response => {
        // const a = {
        //   motivo: this.editItem.motivo,
        //   conclusion: this.editItem.conclusion
        // };
        this.enviar = true;
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
        this.close();
        this.listarCasos();
      });
    },
    validate () {
      if (this.$refs.formEnviar.validate()) {
        // this.snackbar = true;
        this.saveEnvio();
      }
    },
    validateCompletar () {
      if (this.$refs.form.validate()) {
        // this.snackbar = true;
        this.saveOrientacion();
      }
    },
    saveEnvio () {
      let data = {
        flujo_actual_key: this.filaActual.flujo_actual_key,
        flujo_actual_id: this.filaActual.id,
        flujo_destino: this.select_etapa.flujo_destino,
        flujo_destino_key: this.select_etapa.flujo_destino_key,
        proveido: this.proveido,
        responsable_id: this.select_abogado.id
      };
      this.$service['patch']('v1/casos', data).then(response => {
        // this.filaActual.estado = 'ENVIADO';
        this.dialogEnviar = false;
        this.listarCasos();
      });
    },
    generarflujo () {
      this.$service['get'](
        `v1/solicitudes/${this.filaActual.solicitud_id}/tramites`
      ).then(response => {
        this.dialog2 = true;
      });
    },
    listarCasos (filter = '') {
      const { page, rowsPerPage } = this.pagination;
      this.$service['get'](`v1/orientaciones?page=${page}&limit=${rowsPerPage}&q=${filter}`).then(response => {
        this.desserts = [];
        if (response) {
          this.pagination.totalItems = response.count;
          // let d;
          for (let item of response.rows) {
            this.desserts.push({
              ci: item.persona_solicitante.nro_documento,
              nombres: item.persona_solicitante.nombres,
              apellidos: `${item.persona_solicitante.primer_apellido || ''} ${
                item.persona_solicitante.segundo_apellido || ''
              }`,
              solicitante: `${item.persona_solicitante.nombres} ${
                item.persona_solicitante.primer_apellido || ''
              } ${item.persona_solicitante.segundo_apellido || ''}`,
              abogado: `${item.persona_responsable.nombres} ${
                item.persona_responsable.primer_apellido || ''
              }`,
              enviado_por: `${item.persona_envio.nombres} ${
                item.persona_envio.primer_apellido || ''
              }`,
              fecha: item.fecha_creacion,
              codigo: item.codigo,
              id: item.id,
              motivo: item.motivo,
              conclusion: item.conclusion,
              flujo: item.flujo,
              flujo_actual_key: item.flujo_actual_key,
              solicitud_id: item.solicitud_id,
              estado: item.estado,
              centro: item.centro,
              victimaBan: item.victima_id
            });
          }
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/casos/orientaciones/Orientacion.vue